import { render } from "./SheetSongCreate.vue?vue&type=template&id=2747f0e4"
import script from "./SheetSongCreate.vue?vue&type=script&lang=js"
export * from "./SheetSongCreate.vue?vue&type=script&lang=js"
script.render = render

export default script